import { useNavigate } from 'react-router-dom';

const MONTHS = ['', 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
const fmt = (v) => new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(v || 0);

/**
 * Hero banner showing the month target vs actual billing. Gradient card that
 * also links through to the /objetivos page on click.
 */
export default function ObjetivoMesBanner({ objetivoMes, fatMes }) {
  const navigate = useNavigate();
  if (!objetivoMes) return null;

  const totalP = (objetivoMes.VolumePessoal_P || 0) + (objetivoMes.VolumeKits_P || 0) + (objetivoMes.VolumeClientes_P || 0);
  const realMes = fatMes || 0;
  const diff = realMes - totalP;
  const pct = totalP > 0 ? Math.min(100, (realMes / totalP) * 100) : 0;
  const barColor = diff >= 0 ? 'bg-[#00C853]' : 'bg-[#E65100]';

  return (
    <div data-testid="objetivo-mes" onClick={() => navigate('/objetivos')}
      className="mb-6 rounded-2xl p-4 sm:p-6 cursor-pointer hover:shadow-lg transition-all duration-200 text-white relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #0F1829 0%, #2A3A5C 60%, #978D78 100%)' }}>
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 30%, white 0%, transparent 40%), radial-gradient(circle at 80% 70%, white 0%, transparent 30%)' }} />
      <div className="relative flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-between gap-3 sm:gap-6">
        <div className="w-full sm:w-auto">
          <p className="text-[10px] uppercase tracking-[0.2em] sm:tracking-[0.25em] font-medium text-white/70">Objetivo do Mês</p>
          <p className="text-2xl sm:text-3xl font-bold mt-1" style={{ fontFamily: "'JetBrains Mono', monospace" }}>{fmt(totalP)}</p>
          <p className="text-xs sm:text-sm text-white/80 mt-1">Previsto para {MONTHS[objetivoMes.Mes]} {objetivoMes.Ano}</p>
        </div>
        <div className="w-full sm:w-auto sm:text-right">
          <p className="text-[10px] uppercase tracking-[0.2em] sm:tracking-[0.25em] font-medium text-white/70">Realizado</p>
          <p className="text-2xl sm:text-3xl font-bold mt-1" style={{ fontFamily: "'JetBrains Mono', monospace" }}>{fmt(realMes)}</p>
          <p className={`text-xs sm:text-sm mt-1 font-semibold ${diff >= 0 ? 'text-[#A7F3D0]' : 'text-[#FCA5A5]'}`}>
            {diff >= 0 ? '+' : ''}{fmt(diff)} · {pct.toFixed(0)}% atingido
          </p>
        </div>
      </div>
      <div className="relative mt-4 sm:mt-5 h-2 bg-white/20 rounded-full overflow-hidden">
        <div className={`h-full ${barColor} transition-all duration-500`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
